/* eslint-disable react/require-default-props */
/* eslint-disable camelcase */
import React, { useEffect } from 'react';
import SideBarItem from 'components/molecules/side_bar_item';
import SideBarMultipleItem from 'components/molecules/side_bar_multiple_item';
import LogoConlicitaVerde from 'assets/images/logo-conlicita-verde.svg';
import LogoConlicita from 'assets/images/logo-conlicita-branca.svg';

import { useSelector, useDispatch } from 'react-redux';
import { ApplicationState } from 'store';
import {
  MenusBehaviourState,
  MenusBehaviourTypes,
} from 'store/modules/menus_behaviour_store/types';
import { Link } from 'react-router-dom';
import { getNotificationsUnread } from 'store/modules/monitoring_store/actions';
import { PanelState } from 'store/modules/panel_store/types';
import { ProfileState } from 'store/modules/profile_store/types';
import tabId from 'services/tabId';
import ChatbotAssistantIcon from 'components/atoms/chatbot_assistant_icon';
import { Container } from './styles';

interface SideBarProps {
  offlineMode?: boolean;
}

const SideBar = ({ offlineMode = false }: SideBarProps) => {
  const dispatch = useDispatch();
  const { menus_behaviour } = useSelector<ApplicationState, MenusBehaviourState>(
    (state) => state.session.menus_behaviour,
  );
  const { panel } = useSelector<ApplicationState, PanelState>((state) => state.session.panel);
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  useEffect(() => {
    dispatch(
      getNotificationsUnread(
        profile.representant ? profile.currentCompany[tabId()] : profile.clientId,
      ),
    );
  }, []);

  useEffect(() => {
    dispatch(
      getNotificationsUnread(
        profile.representant ? profile.currentCompany[tabId()] : profile.clientId,
      ),
    );
  }, [profile.currentCompany[tabId()]]);

  if (offlineMode) {
    return (
      <Container>
        <div
          className={`dark-bg sidebar-menu ${
            profile.representant ? 'representant' : ''
          } d-print-none ${menus_behaviour.sideBar ? 'open' : 'closed'}-menu
        ${profile.in_sample ? 'hasTopBanner' : ''} ${
            panel?.registration_type_validation === 1 ? 'hasTopBanner' : ''
          }`}
          id="sidebar"
        >
          <div
            className={`box-logo ${
              profile.representant ? 'representant' : ''
            } d-flex justify-content-between align-items-center`}
          >
            <Link title="Logo" className="icon-logo" to="/painel">
              <img
                alt="Tudo sobre Licitações Públicas e Pregão - Conlicitação"
                src={profile.representant ? LogoConlicitaVerde : LogoConlicita}
              />
            </Link>
            <button
              onClick={() => dispatch({ type: MenusBehaviourTypes.CLOSE_SIDEBAR })}
              className="toggle-menu close-menu btn btn-sm btn-link"
              type="button"
            >
              <span className="material-icons">close</span>
            </button>
          </div>
        </div>
      </Container>
    );
  }

  return (
    <Container>
      <div
        className={`dark-bg sidebar-menu ${
          profile.representant ? 'representant' : ''
        } d-print-none ${menus_behaviour.sideBar ? 'open' : 'closed'}-menu
        ${profile.in_sample ? 'hasTopBanner' : ''} ${
          panel?.registration_type_validation === 1 ? 'hasTopBanner' : ''
        }`}
        id="sidebar"
      >
        <div
          className={`box-logo ${
            profile.representant ? 'representant' : ''
          } d-flex justify-content-between align-items-center`}
        >
          <Link title="Logo" className="icon-logo" to="/painel">
            <img
              alt="Tudo sobre Licitações Públicas e Pregão - Conlicitação"
              src={profile.representant ? LogoConlicitaVerde : LogoConlicita}
            />
          </Link>
          <button
            onClick={() => dispatch({ type: MenusBehaviourTypes.CLOSE_SIDEBAR })}
            className="toggle-menu close-menu btn btn-sm btn-link"
            type="button"
          >
            <span className="material-icons">close</span>
          </button>
        </div>
        <div className="scroll-menu">
          <ul className="nav flex-column" id="accordion-menu">
            <SideBarItem representant={profile.representant} feature="Painel" />
            <SideBarItem representant={profile.representant} feature="Boletins de Licitações" />
            <SideBarItem
              representant={profile.representant}
              feature="Encontrar Licitações"
              classTour="find_biddings"
            />
            <SideBarItem representant={profile.representant} feature="Licitações Estratégicas" />
            <SideBarItem representant={profile.representant} feature="Encontrar Acompanhamentos" />
            <SideBarItem
              representant={profile.representant}
              feature="Gerenciar Licitações"
              classTour="manage_biddings"
            />
            <SideBarItem representant={profile.representant} feature="Gerenciar Documentos" />
            {panel?.four_months_left_to_renew && (
              <SideBarItem
                representant={profile.representant}
                feature="Assinatura Digital de Documentos"
              />
            )}
            <SideBarItem representant={profile.representant} feature="Monitorar Chat" />
            <SideBarItem representant={profile.representant} feature="Gerenciar Portais" />
            {panel.allow_robot && (
              <SideBarItem
                representant={profile.representant}
                feature="Robô de Lance Inteligente"
              />
            )}
            {panel?.robo_access && !panel?.validate_services?.robo && (
              <SideBarItem
                representant={profile.representant}
                feature="Robô de Lance Inteligente"
              />
            )}
            {panel?.validate_services?.robo && (
              <SideBarItem
                representant={profile.representant}
                feature="Robô de Lance Inteligente"
              />
            )}
            {panel?.validate_services?.assinatura_digital && (
              <SideBarItem
                representant={profile.representant}
                feature="Assinatura Digital de Documentos"
              />
            )}

            {profile.beta_tester && (
              <SideBarItem representant={profile.representant} feature="Dr. Licita" />
            )}

            <SideBarMultipleItem
              representant={profile.representant}
              feature="Análise Estratégica"
              classTour="market"
            />

            <SideBarMultipleItem
              representant={profile.representant}
              feature="Assessoria e Consultoria"
            />

            <SideBarMultipleItem
              representant={profile.representant}
              feature="Treinamento e Capacitação"
            />

            <SideBarMultipleItem representant={profile.representant} feature="Mais" />
            {profile.alfa_tester && (
              <SideBarMultipleItem
                representant={profile.representant}
                feature="Dashboard Robô de Lances"
              />
            )}
          </ul>
        </div>
        <ul className="nav nav-chatbot tour-chatbot">
          <li className="nav-item text-center">
            <ChatbotAssistantIcon />
          </li>
        </ul>
      </div>
    </Container>
  );
};

export default SideBar;
